<template>
  <div>
      <searchBar :flag="3" @getSearch="searchList"></searchBar>
      <mu-table :fixedFooter="true" :height="tableH" :selectable="false" :showCheckbox="false">
        <mu-thead slot="header" style="font-family: serif;">
          <mu-tr>
            <mu-th width="20%">医生</mu-th>
            <mu-th width="20%">患者</mu-th>
            <mu-th width="20%">使用时间</mu-th>
            <mu-th width="20%">IP</mu-th>
            <mu-th width="20%">操作</mu-th>
          </mu-tr>
        </mu-thead>
        <mu-tbody v-if="caseLists.length>0" style="max-height:400px;">
          <mu-tr v-for="(caseList,index) in caseLists" style="height:60px;">
            <mu-td width="20%">
              {{caseList.doctor}}
            </mu-td>
            <mu-td width="20%">
              <span><a>{{caseList.patient}}</a></span>
            </mu-td>
            <mu-td width="20%">
              <span><a>{{caseList.start_at}}</a></span>
            </mu-td>
            <mu-td width="20%">
              <span><a>{{caseList.ip}}</a></span>
            </mu-td>
            <mu-td width="20%">
              <span class="pointer" v-on:click="showMore(caseList)"><a>详细</a></span>
            </mu-td>
          </mu-tr>
        </mu-tbody>
        <mu-tbody v-else>
          <mu-tr><mu-td style="text-align:center;">---暂无训练信息---</mu-td></mu-tr>
        </mu-tbody>
        <mu-tfoot v-if="caseLists.length>0" slot="footer">
          <mu-tr>
            <mu-pagination :total="totalNum" :current="curPage" @pageChange="handleClick" style="margin-top:20px;" />
            <mu-td style="padding-top:20px;text-align:right;">共 {{totalNum}} 条记录</mu-td>
          </mu-tr>
        </mu-tfoot>
      </mu-table>
    <!--详细信息-->
    <mu-dialog :open="detailDialog" title="">
      <div class="dialog-title">
        <span>训练详情</span>
      </div>
      <div class="dialog-body">
        <table border="0" class="dialog-table">
          <tbody>
          <tr>
            <td class="td-left">使用日期：</td>
            <td>{{chosePatientInfo.start_at}}</td>
          </tr>
          <tr>
            <td class="td-left">IP：</td>
            <td>{{chosePatientInfo.ip}}</td>
          </tr>
          <tr>
            <td class="td-left">医生：</td>
            <td>{{chosePatientInfo.doctor}}</td>
          </tr>
          <tr>
            <td class="td-left">患者：</td>
            <td>{{chosePatientInfo.patient}}</td>
          </tr>
          <tr v-if="showTable">
            <td class="td-left">训练：</td>
            <td>
              <span v-if="chosePatientPlains2.rz.length">言语{{chosePatientPlains2.rz}}</span>
              <span v-if="chosePatientPlains2.yy.length"> &nbsp;认知{{chosePatientPlains2.yy}}</span>
            </td>
            <!--<td>{{chosePatientPlains}}</td>-->
          </tr>
          <tr v-else>
            <td class="td-left">训练：</td>
            <td>
              没有训练记录
            </td>
            <!--<td>{{chosePatientPlains}}</td>-->
          </tr>
          </tbody>
        </table>
      </div>
      <div class="dialog-footer">
        <button @click="close" class="dialog-btn">关闭</button>
      </div>
    </mu-dialog>
    <!--详细信息-->
  </div>
</template>
<script>
  import Vue from 'vue'
  import store from '../../../store/index.js'
  import {getSelect,curDate,getOtherDate} from '../../../assets/js/common.js'
  import searchBar from '../../common/searchBar.vue'

  export default ({
    props:["year","month"],
    store,
    data() {
      return {
        showTrain: false,  // 显示现场训练
        showTable:false,//显示详情
        //数据加载中的标识
        loading: false,
        //数据加载完毕的标识
        loaded: false,
        search: {
          keyword: ''
        },
        caseLists: [],
        curPage: 1,
        totalNum: 1,
        cache : {}, //缓存页码及事件的对象
        detailDialog:false,//点击详细按钮弹窗
        chosePatientInfo:{},//选中患者信息
        chosePatientPlains:new Set(),//选中患者训练记录(测试用)
        chosePatientPlains2:{},//选中患者训练记录2
        // year:this.year,
        // month:this.month,
      }
    },
    filters:{
      usetime(value) {
        var date = new Date(parseInt(value)*1000);
        var Y = date.getFullYear(),
          m = date.getMonth() + 1,
          d = date.getDate(),
          H = date.getHours(),
          i = date.getMinutes(),
          s = date.getSeconds();
        if (m < 10) {
          m = '0' + m;
        }
        if (d < 10) {
          d = '0' + d;
        }
        if (H < 10) {
          H = '0' + H;
        }
        if (i < 10) {
          i = '0' + i;
        }
        if (s < 10) {
          s = '0' + s;
        }
        var t = Y + '.' + m + '.' + d + ' ' + H + ':' + i;
        return t;
      }
    },
    computed: {
      tableH: function(){
        return (document.body.clientHeight - 600)+'px';
      }
    },
    components: {
      searchBar,
    },
    mounted () {
      this.filtrate(this.curPage);
    },
    watch:{
      year:function (newVal,oldVal) {//监听年份的变化
        var self = this;
        let year = newVal;
        let month = self.month;
      },
      month:function (newVal,oldVal){//监听月份的变化
        var self = this;
        let year = self.year;
        let month = newVal;
      }
    },
    methods: {
      close(){
        this.detailDialog = false;
      },
      filtrate(curPage,pageNum){
        var self = this;
        self.loading= true;
        self.loaded= false;
        if (self.cache[curPage]) {
          self.loading= false;
          self.loaded= true;
          self.caseLists = self.cache[curPage].data;
          self.totalNum = self.cache[curPage].page.total;
        }else{
          Vue.http({
            method: 'GET',
            url:'/api/Train/recordTM',
            params: {
              'year':self.year,
              'month':self.month,
              'page': curPage,
              'per_page':pageNum,
              'search': this.search.keyword,
            }
          })
        .then(function(res){
              self.loading= false;
              self.loaded= true;
              var trueData = res.data.data;
              self.caseLists = trueData;
              self.totalNum = res.data.total;
              console.log(self.totalNum)
            }
          );
        }
      },
      handleClick: function(newIndex){
        this.curPage = newIndex;
        this.filtrate(newIndex,10);
      },
      searchList: function(val) {
        this.search = val;
        this.filtrate();
        this.curPage = 1;//每次点击搜索，页标都初始化到第一页
      },
      showMore: function(patientInfo) {
        var self = this;
        self.chosePatientInfo = patientInfo;
        Vue.http({
          method: 'GET',
          url:'/api/Train/detailTM',
          params: {
            'record_id': patientInfo.id
          }
        }).then(res=>{
          self.detailDialog = true;
          let trueData = res.data.data;
          self.getAllPlainName(trueData);//处理训练数据结果
        });
      },
      getAllPlainName(data){
        var self = this;
        var data = data.checked;
        let tmpPlains = {
          'yy':[],
          'rz':[]
        };
        for(let plain in data){
          switch(data[plain]['type']){
            case '10':
              if(data[plain]['counts'] != '0'){
                tmpPlains.yy.push(data[plain]['name']+"*"+data[plain]['counts']);
              }
              break;
            case '20':
              if(data[plain]['counts'] != '0') {
                tmpPlains.rz.push(data[plain]['name'] + "*" + data[plain]['counts']);
              }
              break;
            default:
              break;
          }
        }
        self.chosePatientPlains2 = tmpPlains;
        if(self.chosePatientPlains2.yy.length==0 && self.chosePatientPlains2.rz.length==0){
          self.showTable = false;
        }else{
          self.showTable = true;
        }
      }
    },
    destroyed() {
      this.loading= false;
      this.loaded= false;
    }
  })
</script>

<style lang="stylus" scoped>
  @import "../../../assets/css/app.styl";

  #container
    position absolute
    top 80px
    left 229px
    right 0
    border-left 1px solid #eee
    a
      color $color-font-primary
    .containMore
      position relative
  .dialog-table{
    border-left: 0!important;
  }
  table tbody tr {
    height: 40px;
    border-bottom: 0;
  }
  table tbody tr td{
    text-align:left;
    font-size:14px;
  }
  .td-left{
    text-align:right;
    width:150px;
  }
  .dialog-title{
    text-align:center;
    font-size:22px;
    color:rgba(0, 0, 0, 0.87);
  }
  .dialog-footer{
    text-align:center;
  }
  .dialog-btn{
    width:120px;
    height:40px;
    background-color:#0a81e5;
    font-size:14px;
  }
</style>



// WEBPACK FOOTER //
// showTable.vue?050e9b45